import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ServiceDataCard from "./serviceDataCard";
import "./serviceData.css";

const ServiceData = ({ detailService }) => {

  return (
    <Container fluid className="service-data-container">
      <Row>
        <Col>  
          <ServiceDataCard detailService={detailService} />
        </Col>
      </Row>
    </Container>
  );
};

export default ServiceData;
